import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.66667 8.51087L7.22747 10.07C7.97813 8.75733 9.01707 7.63227 10.2658 6.77953L10.3333 6.7334M14 8C14 11.3137 11.3137 14 8 14C7.7122 14 7.42913 13.9797 7.1522 13.9405C6.34992 13.8271 5.94847 13.7703 5.84286 13.7622C5.67127 13.7489 5.73279 13.7511 5.5607 13.7524C5.45564 13.7532 5.33601 13.7617 5.09875 13.7786L3.65731 13.8816C3.08571 13.9225 2.79988 13.9429 2.58615 13.8415C2.39852 13.7526 2.24742 13.6015 2.15847 13.4139C2.05713 13.2001 2.07755 12.9143 2.11838 12.3427L2.22092 10.9071C2.23815 10.6659 2.24677 10.5453 2.24759 10.4393C2.24893 10.2672 2.25106 10.3287 2.23783 10.1571C2.22968 10.0515 2.17293 9.65027 2.05943 8.8478C2.02026 8.57087 2 8.2878 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgChatCheck);
export default ForwardRef;
